export const STOP_DELAY_MS = 220;
export const START_DELAY_MS = STOP_DELAY_MS + 80;
